
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['click'],
  props: {
    variant: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
});
